const latinToCyrillic = {
	'§': 'ё',

	'q': 'й',
	'w': 'ц',
	'e': 'у',
	'r': 'к',
	't': 'е',
	'y': 'н',
	'u': 'г',
	'i': 'ш',
	'o': 'щ',
	'p': 'з',
	'[': 'х',
	']': 'ъ',

	'a': 'ф',
	's': 'ы',
	'd': 'в',
	'f': 'а',
	'g': 'п',
	'h': 'р',
	'j': 'о',
	'k': 'л',
	'l': 'д',
	';': 'ж',
	'\'': 'э',

	'z': 'я',
	'x': 'ч',
	'c': 'с',
	'v': 'м',
	'b': 'и',
	'n': 'т',
	'm': 'ь',
	',': 'б',
	'.': 'ю',
	'/': '.',

	'1': '1',
	'2': '2',
	'3': '3',
	'4': '4',
	'5': '5',
	'6': '6',
	'7': '7',
	'8': '8',
	'9': '9',
	'0': '0',
}

const cyrillicToLatin = {
	'ё': '§',

	'й': 'q',
	'ц': 'w',
	'у': 'e',
	'к': 'r',
	'е': 't',
	'н': 'y',
	'г': 'u',
	'ш': 'i',
	'щ': 'o',
	'з': 'p',
	'х': '[',
	'ъ': ']',

	'ф': 'a',
	'ы': 's',
	'і': 's',
	'в': 'd',
	'а': 'f',
	'п': 'g',
	'р': 'h',
	'о': 'j',
	'л': 'k',
	'д': 'l',
	'ж': ';',
	'э': '\'',

	'я': 'z',
	'ч': 'x',
	'с': 'c',
	'м': 'v',
	'и': 'b',
	'т': 'n',
	'ь': 'm',
	'б': ',',
	'ю': '.',
	'.': '/',

	'1': '1',
	'2': '2',
	'3': '3',
	'4': '4',
	'5': '5',
	'6': '6',
	'7': '7',
	'8': '8',
	'9': '9',
	'0': '0',
}

export function stringToLatin() {}
// getAlternateKeyboardLayout
export function getAlternateKeyboardLayout(string) {
	let anotherLayout = ''
	string.split('').forEach((str) => {
		if (str.charCodeAt() > 122) {
			anotherLayout += cyrillicToLatin[str] || ''
		} else {
			anotherLayout += latinToCyrillic[str] || ''
		}
	})
	return anotherLayout
}

export function getRandomString(length) {
	let result = ''
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	const charactersLength = characters.length
	let counter = 0
	while (counter < length) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength))
		counter += 1
	}
	return result
}

export function parseFromBase64(string) {
	return JSON.parse(window.atob(string))
}

export function stringifyToBase64(string) {
	return window.btoa(JSON.stringify(string))
}

/**
 * Разбивает строку на число-подобные строки на основе переданных разделителей.
 *
 * @param {string} str - Строка, содержащая числоподобные строки, разделённые разными символами.
 * @param {string[]} [delimiters=[',', ' ', '\n']] - Массив строковых разделителей для разделения чисел. По умолчанию: запятая, пробел и перенос строки.
 * @returns {string[]} - Массив числоподобных строк, извлечённых из строки.
 *
 * @example
 * const inputString = "12, 034\n056 078,90";
 * const numbers = parseNumbersFromString(inputString);
 * console.log(numbers); // ["12", "034", "056", "078", "90"]
 *
 * @example
 * const inputString = "12;0034\t056";
 * const numbers = parseNumbersFromString(inputString, [';', '\t']);
 * console.log(numbers); // ["12", "0034", "056"]
 */
export function parseFloatsFromString(str, delimiters = [',', ' ', ';', '\n']) {
	// Создаём регулярное выражение на основе переданных разделителей
	const delimiterRegex = new RegExp(`[${delimiters.join('')}]`);

	// Разбиваем строку на части
	const parts = str.split(delimiterRegex);

	// Фильтруем только числовые строки
	return parts.map(part => part.match(/\d+/)).filter(Boolean).map(match => match[0]);
}

export function stripHTML(htmlString) {
	// Создаём временный элемент
	const tempDiv = document.createElement('div')

	// Вставляем в него строку с HTML
	tempDiv.innerHTML = htmlString

	// Возвращаем только текстовое содержимое
	return tempDiv.textContent || tempDiv.innerText || ''
}
